import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare const google: any;

/**
 * Loads the Google Maps JS API exactly once and shares the promise between consumers
 * (fleet device map, geo location dialog). The Geocoder ships in the core library,
 * so no extra `libraries=` entries are needed beyond `marker`.
 */
@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
    private loadPromise: Promise<void> | null = null;

    readonly apiKey: string = (environment as any).googleMapsApiKey || '';

    load(): Promise<void> {
        if (this.loadPromise) return this.loadPromise;

        if (!this.apiKey) {
            return Promise.reject(new Error('Google Maps API key not configured'));
        }

        if (typeof google !== 'undefined' && google.maps) {
            this.loadPromise = Promise.resolve();
            return this.loadPromise;
        }

        this.loadPromise = new Promise<void>((resolve, reject) => {
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=marker`;
            script.async = true;
            script.defer = true;
            script.onload = () => resolve();
            script.onerror = () => {
                this.loadPromise = null; // allow retry
                reject(new Error('Failed to load Google Maps'));
            };
            document.head.appendChild(script);
        });
        return this.loadPromise;
    }
}
